/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import CoachCard from './CoachCard';
import { coaches } from '../../data/coaches';
import styles from '../../styles/components/common/ScrollingColumn.module.css';

interface Props {
	direction?: 'up' | 'down';
}

const ScrollingColumn = ({ direction = 'up' }: Props) => {
	const scrollingCoaches = [...coaches, ...coaches]; // ✅ duplicate

	return (
		<div className={styles.wrapper}>
			<div className={`${styles.column} ${styles[direction]}`}>
				{scrollingCoaches.map((coach, index) => (
					<CoachCard
						key={`${coach.id}-${index}`}
						image={coach.image}
						name={coach.name}
						experience={coach.experience}
						gradientColor={coach.gradientColor}
					/>
				))}
			</div>
		</div>
	);
};

export default ScrollingColumn;
